<template>
    <div>
        <div class="full-width-background">
            <v-container fluid class="pa-0">
                <v-row no-gutters style="position: relative;left: 0;right: 0;">
                    <v-col cols="12" class="secondary">
                        <v-card
                            class="secondary primary--text pa-3 "
                            outlined
                            tile
                        >
                            <v-card-text class="primary--text">
                                <p :class="{'display-1': true, 'movil': esMovil}">
                                    Evaluación <b>ambiental</b>, <b>económica</b>
                                    y <b>prestacional</b> de soluciones constructivas</p>
                                <p class="subtitle-1">
                                    Impactos ambientales, costes y características técnicas asociados a la elección de
                                    un
                                    material de recubrimiento, desde pavimentos hasta fachadas, tanto en obra nueva como
                                    en
                                    rehabilitación.
                                </p>
                                <v-btn block color="primary" large @click="goTo('proyecto-nuevo')"
                                       class="boton-inicio"
                                       style="">
                                    {{ $t('iniciar_evaluacion') }}
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div class="">
            <v-container class="pa-0 pt-10">
                <v-row no-gutters>
                    <v-col cols="12" sm="4" class="pa-4 primary--text text-right">
                        <h1>Metodología</h1>
                        <h1>-</h1>
                        <h2>Procedimiento seguido para la evaluación de soluciones constructivas.</h2>
                    </v-col>
                    <v-col cols="12" sm="8" class="pa-4 primary--text izquierda">
                        <h3>Herramienta innovadora.</h3>
                        <p>Solconcer utiliza un enfoque innovador para la evaluación de soluciones constructivas y
                            materiales de revestimiento, que combina aspectos ambientales, económicos y
                            prestacionales.</p>

                        <h3 class="pt-10">Perspectiva de ciclo de vida.</h3>
                        <p>Este enfoque está basado en el Análisis de Ciclo de Vida (ACV) de los materiales. El ACV está
                            considerado como uno de los mejores métodos para evaluar los impactos, ambientales y
                            económicos,
                            asociados a los productos.</p>

                        <h3 class="pt-10">Exigencias técnicas.</h3>
                        <p>Evaluación prestacional basada en los requisitos de los Documentos de Evaluación Europeos
                            exigidos a las soluciones constructivas y en los requisitos esenciales de la obra del
                            Reglamento
                            Europeo de Productos de la Construcción.</p>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div class="full-width-background naranja">
            <v-container class="pa-0 pt-10">
                <v-row no-gutters>
                    <v-col cols="12" sm="4" class="pa-4 primary--text text-right">
                        <h1>Documentos de descarga</h1>
                        <h1>-</h1>
                        <h2>Información para entender y aprovechar al máximo nuestro comparador.</h2>
                    </v-col>
                    <v-col cols="12" sm="8" class="pa-4 primary--text izquierda">
                        <div v-for="(seccion, index) in secciones" :key="index">
                            <h3 class="mt-4"> {{ $options.filters.capitalize(seccion.titulo) }}</h3>
                            <p class="body-1" v-for="(texto, idxSec) in seccion.descripcion"
                               :key="`sec-${index}-${idxSec}-`"
                               v-html="texto"/>
                            <div class="d-flex flex-row flex-wrap">
                                <div v-for="(enlace,index) in seccion.enlaces" :key="index" class="enlace mx-4"
                                     :class="{'hand': hayUsuario, 'descarga': true}" v-ripple="hayUsuario"
                                     @click="abrirPdf(enlace.url)">
                                    <v-tooltip bottom :disabled="hayUsuario">
                                        <template v-slot:activator="{on}">
                                            <div v-on="on">
                                                <v-img :src="require('../../assets/iconos/descarga_white.png')" contain
                                                       width="70" class="ma-auto"></v-img>
                                                <p class="body-1 text-center mt-4">{{
                                                        enlace.descripcion | capitalize
                                                    }}</p>
                                                <v-progress-linear v-show="cargando === enlace.url" indeterminate
                                                                   color="primary"/>
                                            </div>
                                        </template>
                                        <span>{{ $t("alerta_login") }}</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <v-container class="pa-0 pt-10">
            <v-row no-gutters>
                <v-col cols="12" sm="4" class="pa-4 primary--text text-right">
                    <h1>Biblioteca de materiales</h1>
                    <h1>-</h1>
                </v-col>
                <v-col cols="12" sm="8" class="pa-4 primary--text izquierda mb-16 ">
                    <p> Evalúa productos de empresas con información real. Si eres una empresa, regístrate para poder
                        publicar tus materiales.</p>
                    <v-btn color="primary" to="/biblioteca" class="pl-10 pr-10 rounded-0 mt-16" style="font-weight: bolder !important;">Ir a la Biblioteca de
                        materiales <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";
import ImagenesServicio from "@/comunes/servicios/ImagenesServicio";
import {mapState} from "vuex";
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {MOSTRAR_SNACKBAR} from "@/store/store-app";
import DescargasHelper from "@/comunes/helpers/DescargasHelper";


export default {
    props: {
        esIOS: Boolean
    },
    name: 'PaginaPrincipal',
    components: {},
    methods: {
        goTo(path) {
            VueRouteHelper.goTo(path, this.$router);
        },
        imagenS3(url) {
            return ImagenesServicio.urlImagen(url);
        },
        abrirPdf(nombre) {
            if (!this.hayUsuario) return;

            this.cargando = nombre;
            HttpHelper.get(`descargas/pdf/${nombre}`)
                .then((respuesta) => {
                    DescargasHelper.descargarBase64(respuesta.name, respuesta.data, respuesta.extension);
                })
                .catch((error) => {
                    this.$store.commit(MOSTRAR_SNACKBAR, {
                        texto: this.$t(error.status === 403 ? "error_403" : "error_desconocido"),
                        color: "error"
                    });
                })
                .finally(() => {
                    this.cargando = null;
                });
        }
    },
    computed: {
        ...mapState(["usuario"]),
        hayUsuario() {
            return this.usuario != null;
        },
        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        secciones() {
            return [
                {
                    titulo: this.$t("metodologia_titulo"),
                    descripcion: [this.$t("metodologia_texto_1"), this.$t("metodologia_texto_2")],
                    enlaces: [
                        {url: "metodologia", descripcion: this.$t("metodologia_titulo")},
                        {url: "fuentesConsultadas", descripcion: this.$t("fuentes_consultadas")}
                    ]
                },
                {
                    titulo: this.$t("ventas_titulo"),
                    descripcion: [this.$t("ventas_texto")],
                    enlaces: [{url: "ventas", descripcion: this.$t("arg_ventas")}]
                },
                {
                    titulo: this.$tc("solucion_constructiva", 2),
                    descripcion: [this.$t("sc_texto")],
                    enlaces: [
                        {url: "horizontal", descripcion: this.$tc("particion_horizontal", 2)},
                        {url: "vertical", descripcion: this.$tc("particion_vertical", 2)},
                        {url: "fachada", descripcion: this.$tc("particion_fachada", 2)},
                        {url: "urbano", descripcion: this.$tc("particion_urbano", 2)}
                    ]
                }
            ]
        }
    }
};
</script>

<style lang="scss" scoped>
.full-width-background {
    width: 100%;
    background-color: #1ee8b8 !important;

    &.naranja {
        background-color: #F7D9CD !important;
    }
}

.container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

@media (min-width: 576px) {
    .container {
        max-width: 540px;
    }
}

@media (min-width: 768px) {
    .container {
        max-width: 720px;
    }
}

@media (min-width: 992px) {
    .container {
        max-width: 960px;
    }
}

@media (min-width: 1200px) {
    .container {
        max-width: 1140px;
    }
}

.descarga {
    max-width: 20% !important;
    min-width: 20% !important;
}

.display-1 {
    font-size: 2.2rem !important;
    line-height: 2.8rem;
    font-weight: bolder;
    word-wrap: normal;
    max-width: 70%;

    &.movil {
        font-size: 1.8rem !important;
        line-height: 2.2rem;
        padding-top: 2rem;
        max-width: 100%;
    }
}

h1 {
    font-size: 2rem !important;
    line-height: 2.2rem;
    font-weight: 900;
}

.subtitle-1 {
    font-size: 1.3rem !important;
    padding-bottom: 1.3rem !important;
    padding-top: 1.8rem;
    font-weight: 300;
}

h2 {
    font-size: 1.2rem !important;
    font-weight: 300;
}

.boton-inicio {
    border: 2px solid #40108e !important;
    border-radius: 0;
    margin-bottom: 2rem;
    font-size: 1.4rem;
    font-weight: 900;
}

.theme--light.v-btn:hover {
    /*background: var(--v-primary) !important;*/
    background: #40108f !important;
    color: white !important;
}

.v-application.md-up {
    .col-12 .v-card {
        //padding: 0px 90px !important;
    }

    .bloques {
        .izquierda {
            padding-left: calc(50% - 532px) !important;
            padding: 50px 50px 50px calc(50% - 532px) !important
        }

        .derecha {
            padding-right: calc(50% - 532px) !important;
            padding: 50px calc(50% - 532px) 50px 50px !important
        }
    }
}

.v-application.md-down {
    .boton-inicio {
        font-size: 20px;
    }

    .col-12 .v-card {
        padding: 0px 30px !important;
    }

    .bloques {
        .izquierda {
            padding-left: 20px !important;
            /*padding-left: calc(50% - 480px) !important;*/
            /*padding: 50px 50px 50px calc(50% - 480px) !important*/
        }

        .derecha {
            padding-left: 20px !important;
            /*padding-right: calc(50% - 480px) !important;*/
            /*padding: 50px calc(50% - 480px) 50px 50px !important*/
        }
    }
}

.bloques {
    .body-2 {
        font-size: 16px !important;
    }

    .salmon {
        background: #f7d9cd !important;
    }
}

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "iniciar_evaluacion": "INICIAR EVALUACIÓN",
    "bloque_1_titulo": "¿Qué recubrimiento se adapta mejor a tus necesidades?",
    "bloque_1_texto_1": "Descubre con Solconcer las características más<br> representativas de una gran variedad de materiales de<br> recubrimiento.",
    "bloque_1_texto_2": "Analiza y compara resultados en función de los diferentes<br> escenarios propuestos y descárgate los informes con toda<br> la información.",
    "bloque_2_texto": "Impactos ambientales, costes y características técnicas asociados a la elección de un material de recubrimiento, desde pavimentos hasta fachadas, tanto en obra nueva como en rehabilitación.",
    "bloque_3_titulo": "Biblioteca de materiales: evalúa, con la metodología de Solconcer, productos de empresas con información real.",
    "bloque_3_texto": "Si eres una empresa, regístrate para poder publicar tus materiales.",
    "titulo": "Documentos de descarga",
    "descripcion": "Toda la información necesaria para entender y aprovechar al máximo Solconcer.",
    "metodologia_titulo": "Metodología",
    "fuentes_consultadas": "Fuentes consultadas",
    "metodologia_texto_1": "Informe de descarga donde se detalla de manera precisa todos los aspectos relacionados con la metodología de cálculo empleada en Solconcer",
    "metodologia_texto_2": "Además, para ofrecer mayor transparencia, se ofrece otro documento donde se enumeran las fuentes consultadas para la obtención de los datos utilizados para la evaluación de las soluciones constructivas.",
    "sc_texto": "Informes de descarga donde se caracterizan las soluciones constructivas evaluadas y se definen las hipótesis de cálculo consideradas en cada una de ellas.",
    "ventas_titulo": "Argumentario de ventas",
    "ventas_texto": "Documento que pretende, de manera resumida, directa y simplificada, transmitir información relativa a las características de los materiales de recubrimiento que puede ser clave en un proceso de venta. Todo ello basado en la metodología de Solconcer.",
    "arg_ventas": "Argumentario de ventas",
    "alerta_login": "Regístrate o inicia sesión para poder descargar los documentos",
    "error_403": "No se pueden descargar los documentos si no ha aceptado la política de privacidad. Debe acceder a su perfil para aceptarla"
    }
}
</i18n>
<!-- @formatter:on -->
